import { List, Text } from '@mantine/core';
import { useHover } from '@mantine/hooks';
import { IconExternalLink } from '@tabler/icons-react';
import React from 'react';

const SMEItem: React.FC<{ linkURL: string; name: string }> = ({ linkURL, name }) => {
  const { hovered, ref } = useHover();
  return (
    <List.Item>
      <Text
        ref={ref}
        component='a'
        fz={14}
        href={linkURL}
        target='_blank'
        c={hovered ? 'primary' : 'dark'}
        td={hovered ? 'underline' : ''}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 4
        }}
      >
        {name}
        {hovered && <IconExternalLink size={16} />}
      </Text>
    </List.Item>
  );
};

export default SMEItem;
